import { Grid, Typography, styled } from '@mui/material';

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.grey[400]}`,
}));
StyledGridContainer.defaultProps = {
  container: true,
  item: true,
};

export const StyledGridItem = styled(Grid)({
  padding: 0,
});
StyledGridItem.defaultProps = {
  item: true,
};

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.grey[400],
}));

export const StyledDurationTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.grey[400],
  textAlign: 'center',
}));

export const StyledStatusTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.grey[400],
  textAlign: 'center',
}));
